<script lang="ts">
    import src from './svg/official/Icon step 4.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />
